// extracted by mini-css-extract-plugin
module.exports = {"row":"SkeletonVersionTableRow_row__1JMJd"};